import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useUserContext, getFreshAccessToken } from './UserContext';

const baseUrl = process.env.REACT_APP_API_URL;
const endpointEvents = `${baseUrl}/events`;

const EventContext = createContext();

export const EventProvider = ({ children }) => {
  const { tokens, userInfo } = useUserContext(); // ✅ On utilise userInfo ici
  const [events, setEvents] = useState([]);
  const [loadingEvents, setLoadingEvents] = useState(true);
  const [errorEvents, setErrorEvents] = useState(null);

const fetchEvents = async () => {
  const attemptFetch = async (tokenToUse) => {
    const username = userInfo?.username;
    if (!tokenToUse || !username) throw new Error("Token ou nom d'utilisateur manquant.");

     // 👇 Payload selon le rôle
      const payload = userInfo?.isAdmin
        ? { scope: 'all' }                 // Admin: tous les events
        : { createdBy: username };         // User: seulement ses events

    const response = await axios.post(
      endpointEvents,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${tokenToUse}`,
        },
      }
    );

    let data = [];
    const body = response?.data?.body;
    if (body) {
      try {
        data = JSON.parse(body);
      } catch (e) {
        console.error("[EventContext] Erreur de parsing JSON : ", e, "body reçu : ", body);
        throw new Error("Erreur lors du parsing JSON des événements.");
      }
    } else if (Array.isArray(response.data)) {
      data = response.data;
    } else {
      throw new Error("Donnée de réponse événement vide ou mal formatée.");
    }

    return data;
  };

  setLoadingEvents(true);
  try {
    const initialToken = tokens?.accessToken;
    let data = await attemptFetch(initialToken);
    setEvents(data);
    setErrorEvents(null);
  } catch (err) {
    console.warn('[EventContext] Échec initial, tentative de refreshToken...');
    try {
      const refreshedToken = await getFreshAccessToken();
      if (!refreshedToken) throw new Error('Échec de rafraîchissement du token');
      const data = await attemptFetch(refreshedToken);
      setEvents(data);
      setErrorEvents(null);
    } catch (secondErr) {
      console.error('[EventContext] Erreur fetchEvents après retry :', secondErr);
      setErrorEvents(secondErr.message);
    }
  } finally {
    setLoadingEvents(false);
  }
};


  useEffect(() => {
    if (tokens?.accessToken && userInfo?.username) {
      fetchEvents();
    } else {
      //console.log('[EventContext] En attente du token ou de userInfo...');
    }
  }, [tokens, userInfo]);

  return (
    <EventContext.Provider value={{ events, loadingEvents, errorEvents, refetchEvents: fetchEvents }}>
      {children}
    </EventContext.Provider>
  );
};

export const useEventContext = () => useContext(EventContext);
